module.exports = __webpack_public_path__ + "static/img/11.060e3b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/zh/11.png
// module id = 50be
// module chunks = 0